module.exports = __webpack_public_path__ + "media/images/challenges/talent-league-iv/chevron-1c241848c84f6253c5dc2349340a0855.svg";